export default __webpack_public_path__ + "static/media/MyAlgo.4d0f9b92.svg";